class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);
    
    this.whitebox = document.getElementById('white-box-id');
    
    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );

    this.addEventListener('click', (event) => {
      if (event.target === this) this.close();
    });
  }

  open() {
    this.notification.classList.add('animate', 'active');
    if (window.innerWidth < 1080) {
      //$("body").toggleClass('overflow-hidden');
      document.body.classList.add('overflow-hidden');
    }
    this.whitebox.style.display = 'none';
    this.setAttribute('open', '');

    this.notification.addEventListener(
      'transitionend',
      () => {
        this.notification.focus();
        trapFocus(this.notification);
      },
      { once: true }
    );
    document.body.addEventListener('click', this.onBodyClick);
  }

  close() {
    this.notification.classList.remove('active');
    document.body.removeEventListener('click', this.onBodyClick);
    /*
    if (window.innerWidth < 1080) {
     $("body").toggleClass('overflow-hidden');
    }
    */
    document.body.classList.remove('overflow-hidden');
    this.whitebox.style.display = 'block';
    this.removeAttribute('open');
    
    removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState) {
    this.cartItemKey = parsedState.key;
    this.getSectionsToRender().forEach((section) => {
      document.getElementById(section.id).innerHTML = this.getSectionInnerHTML(
        parsedState.sections[section.id],
        section.selector
      );
    });
    const addedItemMeta = document.querySelector('#cart-notification-product .js-cart-added-item-meta');
    const sofaMessage = document.getElementById('cart-notification-sofa-message');
    if (sofaMessage) {
      const isSofa = addedItemMeta?.dataset?.isSofa === 'true';
      sofaMessage.hidden = !isSofa;
    }

    if (this.header) this.header.reveal();
    this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: `[id="cart-notification-product-${this.cartItemKey}"]`,
      },
      {
        id: 'cart-notification-button',
      },
      {
        id: 'cart-icon-bubble',
      },
      {
        id: 'cart-notification-shipping',
      },
      {
        id: 'cart-bar',
        selector: '#cart-bar',
      },
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure, header-menu');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}
 
customElements.define('cart-notification', CartNotification);
